import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import {
  SigninManager,
  RequestPasswordResetManager,
  SellerSignupManager,
} from 'sham-components/shared/auth';
import { SellerSigninManager } from './services/signin-manager.service';
import { ProductsManager } from './features/products/products-manager';
import { provideSharedProfile } from 'sham-components/shared/profile';
import { SellerProfileAdapter } from './services/profile-adapter';
import { sellerGuestGuard, sellerDashboardGuard } from './guards/seller-access.guard';
export const routes: Routes = [
  // TODO: re-enable canActivate guards after testing
  {
    path: 'signup',
    // canActivate: [guestGuard],
    loadChildren: () =>
      import('sham-components/shared/auth').then((m) => m.sellerSignupRoutes),
  },
  {
    path: 'login',
    canActivate: [sellerGuestGuard],
    loadComponent: () =>
      import('./features/auth/seller-signin/seller-signin').then(
        (x) => x.SellerSigninComponent,
      ),
    providers: [{ provide: SigninManager, useClass: SellerSigninManager }],
  },
  { path: 'signin', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'request-password-reset',
    // canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/request-password-reset/request-password-reset').then(
        (x) => x.RequestPasswordResetComponent,
      ),
    providers: [RequestPasswordResetManager],
  },
  {
    path: 'reset-password',
    // canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'confirm-email',
    // canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/confirm-email/confirm-email').then(
        (m) => m.ConfirmEmailComponent,
      ),
  },
  {
    path: 'app',
    canActivate: [sellerDashboardGuard],
    canActivateChild: [sellerDashboardGuard],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'),
  },
  {
    path: '**',
    redirectTo: '/login',
  },

  { pathMatch: 'prefix', path: '', redirectTo: 'dashboard' },
  {
    title: 'New Product',
    path: 'new-product',
    redirectTo: 'products/new',
    pathMatch: 'prefix',
  },
  {
    title: 'Products',
    path: 'products',
    loadChildren: () => import('./features/products/products.routes'),
    providers: [ProductsManager],
  },
  {
    title: 'Orders',
    path: 'orders',
    loadChildren: () => import('./features/orders/orders.routes'),
  },
  {
    title: 'Warehouses',
    path: 'warehouses',
    loadChildren: () => import('./features/warehouses/warehouses.routes'),
  },
  {
    title: 'Profile',
    path: 'profile',
    loadComponent: () =>
      import('sham-components/shared/profile').then((m) => m.SharedProfilePage),
    providers: [
      ...provideSharedProfile(
        {
          userType: 'seller',
          title: 'Profile',
          subtitle: 'Manage seller profile information.',
          fields: [
            { key: 'fullName', label: 'Full Name', editable: true, required: true },
            { key: 'email', label: 'Email', editable: false, inputType: 'email' },
            {
              key: 'phoneNumber',
              label: 'Personal Phone Number',
              editable: true,
              inputType: 'phone',
            },
            {
              key: 'dateOfBirth',
              label: 'Date Of Birth',
              editable: true,
              inputType: 'date',
            },
            {
              key: 'storeName',
              label: 'Store Name',
              editable: true,
              showFor: ['seller'],
            },
            { key: 'address', label: 'Address', editable: true },
          ],
        },
        SellerProfileAdapter,
      ),
    ],
  },
  {
    title: 'Dashboard',
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard').then((m) => m.Dashboard),
  },
  {
    title: 'Payments',
    path: 'payments',
    loadComponent: () =>
      import('./features/payments/payments').then((m) => m.Payments),
  },
  {
    title: 'Coupons',
    path: 'coupons',
    loadChildren: () => import('./features/coupons/coupons.routes'),
  },
  {
    title: 'Refunds',
    path: 'refunds',
    loadChildren: () => import('./features/refunds/refunds.routes'),
  },
  {
    title: 'Accounting',
    path: 'accounting',
    loadComponent: () =>
      import('./features/accounting/accounting').then((m) => m.Accounting),
  },
];
